import '@/modules/card';
import Swiper from 'swiper';
import SwiperCore, { Pagination, Navigation, Scrollbar } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Pagination, Navigation, Scrollbar]);

export default class ProductCarouselToggle {
    constructor(sliderElement) {
        if (!sliderElement) return;

        this.sliderElement = sliderElement;
        this.wrapper = this.sliderElement.querySelector('.swiper-wrapper');
        this.arrowNext = this.sliderElement.querySelector('.swiper-button-next');
        this.arrowPrev = this.sliderElement.querySelector('.swiper-button-prev');
        this.scrollbar = this.sliderElement.querySelector('.swiper-scrollbar');
        this.slideToggles = this.sliderElement.closest('.wrap')?.querySelectorAll('.js-slides-toggle') || [];
        this.slideToggleAll = this.sliderElement.closest('.wrap')?.querySelector('.js-slides-all');

        // Store all slides outside the DOM so we can selectively re-insert them
        this.allSlides = [...this.sliderElement.querySelectorAll('.js-slide')];

        this.swiper = null;
        this.initSwiper();
        this.bindEvents();
    }

    get swiperConfig() {
        return {
            slidesPerView: 1,
            spaceBetween: 20,
            threshold: 10,
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev
            },
            scrollbar: {
                el: this.scrollbar,
                draggable: true,
                hide: false
            },
            breakpoints: {
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 4 }
            }
        };
    }

    initSwiper() {
        if (this.swiper && !this.swiper.destroyed) {
            this.swiper.destroy(true, true);
        }
        this.swiper = new Swiper(this.sliderElement, this.swiperConfig);
    }

    filter(type) {
        // Put all slides back in the wrapper first
        this.allSlides.forEach(slide => this.wrapper.appendChild(slide));

        // Remove non-matching slides from the wrapper (they stay in this.allSlides)
        if (type !== 'all') {
            this.allSlides.forEach(slide => {
                const collections = (slide.dataset.collections || '').split('|').filter(Boolean);
                if (!collections.includes(type)) {
                    this.wrapper.removeChild(slide);
                }
            });
        }

        this.initSwiper();
    }

    bindEvents() {
        if (this.slideToggleAll) {
            this.slideToggleAll.addEventListener('click', () => {
                this.filter('all');
                this.slideToggleAll.classList.add('active');
                this.slideToggles.forEach(b => b.classList.remove('active'));
            });
        }

        this.slideToggles.forEach(button => {
            button.addEventListener('click', () => {
                this.filter(button.dataset.type);
                this.slideToggleAll?.classList.remove('active');
                this.slideToggles.forEach(b => b.classList.remove('active'));
                button.classList.add('active');
            });
        });
    }
}
